import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { testimonials } from '../data/social';
export function Testimonials() {
  return <section className="w-full bg-cream px-4 py-16 sm:py-24" data-id="element-349" data-mp="3fycoti6qzx8o">
      <div className="mx-auto max-w-5xl" data-id="element-350" data-mp="3b1471ipihv7y">
        <SectionHeading eyebrow="In Their Own Words" title="What Dental Professionals Are Saying" data-id="element-351" data-mp="3b01fr9oa1qri" />

        <div className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-352" data-mp="370k9wf4xurlt">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 ring-1 ring-ink/5 sm:p-8" data-id="element-353" data-mp="31ybg5gk8rlin">
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-354" data-mp="2x11sa5ci3hwx">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-355" data-mp="v96ixwdpvphv" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 text-[17px] leading-relaxed text-ink" data-id="element-356" data-mp="qbn7134hrot3">“{t.quote}”</blockquote>
              <figcaption className="mt-auto flex items-center gap-4 pt-6" data-id="element-357" data-mp="h55a40zwdtwk">
                <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-brand-light" loading="lazy" data-id="element-358" data-mp="m5b4vq1grwiv" />
                <div data-id="element-359" data-mp="c7df2y3yhro5">
                  <p className="font-extrabold text-ink" data-id="element-360" data-mp="c8okt3gyp9hw">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-361" data-mp="zwy33veyvf4a">{t.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <div className="mt-12" data-id="element-362" data-mp="q7650r7ns3v2">
          <CTAButton label="I Want the Same Clarity in My Case Reviews" data-id="element-363" data-mp="q5v36wxrx66l" />
        </div>
      </div>
    </section>;
}